export default __webpack_public_path__ + "static/media/DraIvani.2d2735c3.png";